/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AddonStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
